import type { AxiosInstance } from 'axios'

export default () => useNuxtApp().$axios as AxiosInstance